import { render, staticRenderFns } from "./HallOfFameIndex.vue?vue&type=template&id=732fb9dc&scoped=true"
import script from "./HallOfFameIndex.vue?vue&type=script&lang=js"
export * from "./HallOfFameIndex.vue?vue&type=script&lang=js"
import style0 from "./HallOfFameIndex.vue?vue&type=style&index=0&id=732fb9dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732fb9dc",
  null
  
)

export default component.exports